<button
  type="button"
  tabindex="-1"
  [popover]="texto"
  [popoverTitle]="titulo"
  [popoverCloseOnMouseOutside]="true"
  [popoverOnHover]="isPopoverOnHover"
  [popoverPlacement]="placement"
  class="pop-over-help"
  data-trigger="focus"
  data-toggle="popover"
  data-placement="top"
  [ngClass]="{
    smaller: isSmall,
    static: isPositionStatic
  }"
>
  <span
    class="fa fa-question-circle"
    [ngClass]="{ 'bg-blue': backgroundBlue }"
  ></span>
</button>
